export const SWITCH_MODAL_STATE  = 'SWITCH_MODAL_STATE';